/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_u45m_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What is deliberate practice?`)
};

const es_timer_u45m_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué es la práctica deliberada?`)
};

const de_timer_u45m_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was ist gezieltes Üben (Deliberate Practice)?`)
};

const nl_timer_u45m_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat is doelgerichte oefening?`)
};

const fr_timer_u45m_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qu’est-ce que la pratique délibérée ?`)
};

const it_timer_u45m_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cos'è la pratica intenzionale?`)
};

const pt_br2_timer_u45m_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que é prática deliberada?`)
};

const pt_timer_u45m_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que é a prática deliberada?`)
};

const ja_timer_u45m_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`意図的な練習とは何ですか？`)
};

const zh_timer_u45m_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`什么是刻意练习？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_u45m_faq4_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_u45m_faq4_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_u45m_faq4_q", locale)
	if (locale === "en") return en_timer_u45m_faq4_q(inputs)
	if (locale === "es") return es_timer_u45m_faq4_q(inputs)
	if (locale === "de") return de_timer_u45m_faq4_q(inputs)
	if (locale === "nl") return nl_timer_u45m_faq4_q(inputs)
	if (locale === "fr") return fr_timer_u45m_faq4_q(inputs)
	if (locale === "it") return it_timer_u45m_faq4_q(inputs)
	if (locale === "pt-BR") return pt_br2_timer_u45m_faq4_q(inputs)
	if (locale === "pt") return pt_timer_u45m_faq4_q(inputs)
	if (locale === "ja") return ja_timer_u45m_faq4_q(inputs)
	return zh_timer_u45m_faq4_q(inputs)
};